/**
 * Les chiffres clés.
 *
 * Les valeurs sont du TEXTE, pas des nombres : le modèle de blocs est
 * strictement textuel, et un champ numérique serait jeté par le serveur.
 * C'est d'ailleurs ce qu'il faut — « < 5 min » et « 2 648 » ne sont pas
 * des nombres, et `valeur` reste traduisible : « < 5 min » doit devenir
 * « < 5 λεπτά ».
 */
const ChiffresBloc = ({ bloc }) => {
    const chiffres = Array.isArray(bloc?.chiffres) ? bloc.chiffres : [];
    if (chiffres.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-chiffres">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5 text-center">{bloc.titre}</h2>
            )}
            <div className="grid gap-4 grid-cols-2 md:grid-cols-4">
                {chiffres.map((c, i) => (
                    <div key={i} className="text-center rounded-xl bg-gray-50 px-3 py-5">
                        <p className="text-2xl md:text-3xl font-bold text-cabaza-purple tabular-nums">
                            {c.valeur}
                        </p>
                        {c.libelle && (
                            <p className="text-sm text-gray-600 mt-1">{c.libelle}</p>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ChiffresBloc;
